import { render, staticRenderFns } from "./waterByStu.vue?vue&type=template&id=2d983c8a&"
import script from "./waterByStu.vue?vue&type=script&lang=js&"
export * from "./waterByStu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports